import React from "react";
import cn from "classnames";

import folderIcon from "@src/assets/svg/folder-icon.svg";
import nodeIcon from "@src/assets/svg/node-unselected-icon.svg";

import styles from "./ancestors-lineage-tree.module.scss";
import { useI18N } from "@src/language/language-context";

const cssClassName = "ancestors-lineage-tree";

interface OurNodeAncestorsLineageTreePropTypes {
  nodeId: string;
  label: string;
  useHook: (nodeId: string) => string[];
}

export const OurNodeAncestorsLineageTree = ({
  nodeId,
  label,
  useHook,
}: OurNodeAncestorsLineageTreePropTypes) => {
  const i18n = useI18N();
  const ancestors = useHook(nodeId);
  const returnLastElementOfArray = (array) => {
    return array.length - 1;
  };

  const returnIconForLineage = (index, array) => {
    return index === returnLastElementOfArray(array) ? nodeIcon : folderIcon;
  };

  return (
    <div className={styles[`${cssClassName}__id-wrapper`]}>
      <div className={styles[`${cssClassName}__id-label-wrapper`]}>
        <div className={styles[`${cssClassName}__id-label-wrapper-label`]}>
          {label}
        </div>
      </div>
      {Array.isArray(ancestors) && ancestors.length > 1 ? (
        <div className={styles[`${cssClassName}__tree-wrapper`]}>
          {ancestors.map((item, i) => (
            <div
              key={`item ${i}`}
              style={{ marginLeft: i * 10 }}
              className={cn(styles[`${cssClassName}__tree-node`], {
                [styles[`${cssClassName}__tree-node--selected`]]:
                  i === returnLastElementOfArray(ancestors),
              })}
            >
              <img
                src={returnIconForLineage(i, ancestors)}
                alt={`${item} icon`}
              />
              <span className={styles[`${cssClassName}__item-label`]}>
                {item}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <div className={styles[`${cssClassName}__id-value-wrapper`]}>
          <p>{i18n("modules.ourNodeAncestorsLineageTree.noAncestors")}</p>
        </div>
      )}
    </div>
  );
};
